module.exports = __webpack_public_path__ + "9cbcd20c7ccb33ad61f539393dd2a3bb.png";